import { FC } from 'react';
import Interview from 'types/Interview';
import { getLocaleDate, getLocaleTime } from 'utils/time';
import { Container } from './components';

type Props = {
  interview: Interview | undefined;
};
const Accepted: FC<Props> = ({ interview }) => {
  return (
    <Container>
      <p>
        L'entretien a été accepté par le mentoré. Il aura lieu le{' '}
        {interview?.date && getLocaleDate(interview.date)} à{' '}
        {interview?.date && getLocaleTime(interview.date)}.
      </p>
    </Container>
  );
};

export default Accepted;
